import entertainmentImage from "../assets/entertainment.webp"; // use your uploaded image
import iconCustomer from "../assets/customer.png";
import iconSecurity from "../assets/security.png";
import iconBackend from "../assets/backend.png";
import iconAnalytics from "../assets/data.png";
import partyImage from "../assets/enter.webp"; // Update path as needed
import checkIcon from "../assets/check-icon.png"; // Your uploaded check icon
import icon1 from "../assets/feature1.png";
import icon2 from "../assets/feature2.png";
import icon3 from "../assets/feature3.png";
import checkIIcon from "../assets/check-purple.png";
import { motion } from "framer-motion";
import { useState, useEffect,useRef } from "react";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import { useNavigate } from 'react-router-dom'; 
import { toast, ToastContainer } from "react-toastify";
 
import { Helmet } from "react-helmet";





export default function EntertainmentSection() {
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };
   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
    const [isCompanyOpen, setIsCompanyOpen] = useState(false);
  
    const toggleMobileMenu = () => {
      setIsMobileMenuOpen(!isMobileMenuOpen);
    };
  
    const toggleServicesDropdown = () => {
      setIsServicesOpen(!isServicesOpen);
    };
  
    const toggleIndustriesDropdown = () => {
      setIsIndustriesOpen(!isIndustriesOpen);
    };
  
    const toggleCompanyDropdown = () => {
      setIsCompanyOpen(!isCompanyOpen);
    };

    const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };
    const featuresData = [
  {
    icon: icon1,
    title: "Streamlined booking experience",
    description:
      "Lentera's ticket booking system is a prime example of their commitment to offering cutting edge digital solutions that improve consumer experiences.",
    points: ["Intuitive User Interface", "Secure Transaction Process"],
  },
  {
    icon: icon2,
    title: "Enhanced security & Reliability",
    description:
      "Transparent, data-driven feedback promotes accountability and continuous improvement through objective decision-making.",
    points: ["Robust Backend Infrastructure", "Secure Payment Methods"],
  },
  {
    icon: icon3,
    title: "Enhanced customer service & Analytics",
    description:
      "Transparent, data-driven feedback promotes accountability and continuous improvement through objective decision-making.",
    points: ["Data-Driven Analytics", "Enhanced Customer Service"],
  },
];
    const features = [
  "The site includes an easy-to-use design that makes buying tickets simple and available to all users.",
  "By ensuring that transactions are reliable and safe, integrated secure payment gateways let users feel more confident.",
  "Backend infrastructure maintains stability and dependability due to its high traffic volume handling capacity.",
  "The interface supports multi-device responsiveness, providing a smooth experience on desktop and mobile.",
  "Smart analytics help track user behavior and optimize ticket sales in real-time.",
];

const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
   // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
    const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    <>
   
<Helmet>
        <title>Entertainment Software & Ticketing Solutions | LENTERA Digital Platforms</title>
        <meta name="description" content=" Transform the live event experience with LENTERA’s innovative entertainment software and ticket booking system. Enjoy seamless navigation, secure payments, multi-device access, and data-driven insights to enhance engagement and customer satisfaction."/>
        <meta name="keywords" content="LENTERA entertainment platform, personalized entertainment recommendations, backend integration for events."/>
      </Helmet>

    <section className="w-full min-h-[] bg-black text-white font-poppins overflow-hidden relative">
     <div className="w-full min-h-screen flex flex-col-reverse lg:flex-row items-center justify-between px-6 lg:px-20 relative z-10">
      
      {/* Left: Text + gradient blur background */}
      <div className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left relative z-10 py-12">
        {/* Blurred gradient background layer */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#EF3BF2] via-[#7B41E6] to-black blur-3xl opacity-60 z-0" />

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
          className="relative z-10"
        >
          <p className="text-sm font-medium text-white/70 uppercase tracking-wide mb-4">
            Entertainment
          </p>
          <h1 className="text-[32px] sm:text-[40px] lg:text-[48px] font-bold leading-tight mb-6">
            Excitement meets <br /> unforgettable experiences
          </h1>
          <p className="text-base sm:text-lg text-[#D4D4D8] max-w-xl mx-auto lg:mx-0">
            Discover a world where every moment is filled with excitement and unforgettable experiences that inspire, entertain, and connect.
          </p>
        </motion.div>
      </div>

      {/* Right: Image with animation */}
      
<motion.div
  initial={{ opacity: 0, scale: 0.95 }}
  whileInView={{ opacity: 1, scale: 1 }}
  transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
  viewport={{ once: true }}
  className="w-full lg:w-1/2 flex justify-center lg:justify-end"
>
  <div className="relative w-[100px] h-[300px] sm:h-[400px] md:h-[400px] lg:h-auto lg:min-h-screen lg:absolute lg:top-0 lg:bottom-0 lg:right-0 lg:w-1/2">
    <img
      src={entertainmentImage}
      alt="Entertainment VR"
      className="absolute top-0 right-0 bottom-0 w-full h-full object-cover"
    />
  </div>
</motion.div>

    </div>
      
    
<section className="w-full bg-[#121212] text-white font-poppins px-6 lg:px-20 py-12">
      <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-stretch gap-12 lg:gap-0 relative">
        
        {/* Left Block */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="w-full lg:w-1/2 pr-0 lg:pr-10"
        >
          <h2 className="text-xl sm:text-2xl font-semibold mb-4">Overview</h2>
          <p className="text-[#D4D4D8] text-base leading-relaxed">
            Lentera introduces a smart, user-friendly ticketing system designed to transform the concert experience.
            This innovative platform streamlines access to live events, reflecting LENTERA’s commitment to digital
            innovation and creative solutions.
          </p>
        </motion.div>

        {/* Divider */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          viewport={{ once: true }}
          className="hidden lg:block w-px bg-[#D4D4D8]/30 mx-10"
        />

        {/* Right Block */}
        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="w-full lg:w-1/2 lg:pl-10"
        >
          <h2 className="text-xl sm:text-2xl font-semibold mb-4">
            Our impact on entertainment <br className="hidden sm:block" />
            platforms
          </h2>
          <p className="text-[#D4D4D8] text-base leading-relaxed">
            This entertainment software offers an all-in-one platform for games, movies, music, and live streams,
            with smooth navigation and personalized recommendations to boost engagement.
          </p>
        </motion.div>
      </div>
    </section>
   <section className="w-full bg-black text-white px-4 lg:px-24 py-20 font-poppins">
  <div className="max-w-screen-xl mx-auto">
    {/* Top Heading */}
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="flex flex-col lg:flex-row justify-between items-start mb-12"
    >
      <h2 className="text-3xl sm:text-4xl font-bold leading-tight max-w-md">
        Next-Level <br /> advantages await
      </h2>
      <p className="text-[#D4D4D8] text-base mt-4 lg:mt-0 max-w-lg">
        Experience smarter solutions, seamless performance, and impactful results — because with LENTERA, next-level advantages are just the beginning.
      </p>
    </motion.div>

    {/* Cards Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {[iconCustomer, iconSecurity, iconBackend, iconAnalytics].map((icon, index) => {
        const titles = [
          "Customer centric approach",
          "User experience & security",
          "Backend flexibility",
          "Advanced analytics"
        ];
        const descs = [
          "Lentera’s ticket booking system delivers superior digital solutions with a user-first design and a seamless, easy-to-use interface.",
          "With real-time seat availability and secure payments, users can easily select seats, navigate the platform, and book with confidence and ease.",
          "Easily integrate with various APIs, databases, and infrastructure tools for faster and more adaptable system operations.",
          "Gain powerful insights into customer behavior and operational efficiency to make informed, data-driven decisions."
        ];
        return (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.1 }}
            viewport={{ once: true }}
            className="bg-[#1E1E1E] rounded-3xl p-8"
          >
            <img src={icon} alt={titles[index]} className="w-20 h-20 mb-6 object-contain" />
            <h3 className="text-lg font-semibold mb-3">{titles[index]}</h3>
            <p className="text-[#D4D4D8] text-sm leading-relaxed">{descs[index]}</p>
          </motion.div>
        );
      })}
    </div>
  </div>
</section>

{/* Innovative Ticket Booking Section */}
<div className="bg-black text-white font-poppins px-6 md:px-20 py-20">
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
    className="text-center mb-16"
  >
    <h1 className="text-4xl md:text-5xl font-bold mb-4">Innovative ticket booking system</h1>
    <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
      Experience the future of live events with our Innovative Ticket Booking System — where convenience, security, and seamless access come together like never before.
    </p>
  </motion.div>

  <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
    {/* Image */}
    <motion.div
      initial={{ opacity: 0, x: -60 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="w-full lg:w-1/2 flex justify-center lg:justify-end"
    >
      <img src={partyImage} alt="Party Event" className="w-full max-w-md lg:max-w-[500px] rounded-3xl shadow-2xl object-cover" />
    </motion.div>

    {/* Features List */}
    <motion.div
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="w-full lg:w-1/2"
    >
      <div className="mb-6">
        <span className="text-gray-400 font-semibold text-sm uppercase tracking-wider">Features</span>
        <div className="border-t border-dashed border-gray-500 w-44 mt-1" />
      </div>

      <div className="space-y-6">
        {features.map((text, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            viewport={{ once: true }}
            className="flex items-start bg-gradient-to-r from-[#2c026c] to-[#18003a] rounded-2xl px-6 py-5"
          >
            <img src={checkIcon} alt="Check" className="w-6 h-6 mt-1 mr-4 shrink-0" />
            <p className="text-base md:text-lg leading-relaxed text-white">{text}</p>
          </motion.div>
        ))}
      </div>
    </motion.div>
  </div>
</div>

{/* Key Features Section */}
<section className="bg-black text-white font-poppins px-6 md:px-20 py-20">
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
    className="text-center mb-16"
  >
    <h2 className="text-4xl md:text-5xl font-bold mb-4">Key features</h2>
    <p className="text-lg text-gray-300">Discover the game-changing key features that set you apart!</p>
  </motion.div>

  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
    {featuresData.map((feature, index) => (
      <motion.div
        key={index}
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: index * 0.1 }}
        viewport={{ once: true }}
        className="bg-gradient-to-b from-[#000000] to-[#402374] rounded-3xl p-8 text-center shadow-lg flex flex-col justify-between"
      >
        <img src={feature.icon} alt="Feature Icon" className="w-16 h-16 mx-auto mb-4" />
        <h3 className="text-xl font-semibold mb-4">{feature.title}</h3>
        <p className="text-gray-300 mb-6">{feature.description}</p>
        <div className="border border-[#5F4396] border-opacity-40 rounded-xl px-4 py-4 text-left space-y-3 bg-[#5F4396] bg-opacity-10">
          {feature.points.map((point, i) => (
            <div key={i} className="flex items-center gap-3">
              <img src={checkIIcon} alt="Check" className="w-5 h-5" />
              <span>{point}</span>
            </div>
          ))}
        </div>
      </motion.div>
    ))}
  </div>
</section>
</section>
         <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
    <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">Blog</a></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><a href="https://blog.lentera.in/" className="hover:text-white">News</a></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>
        </>

  );
}